import React, { type SFC } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { MANAGE_VIEW_PATH } from "./views/ManageView";
import RaangeLabel, {
  type IRaangeLabelProps,
} from "src/shared/components/RaangeLabel";
import type ILinkable from "src/shared/formatters/ILinkable";

export interface IManageLabelProps
  extends Omit<IRaangeLabelProps, "fa">,
    ILinkable {}

export const ManageLabel: SFC<IManageLabelProps> = (props) => {
  const { hasLink = false } = props;
  const label = (
    <RaangeLabel fa="user" {...props}>
      <FormattedMessage id="manage" />
    </RaangeLabel>
  );
  if (hasLink) {
    return <Link to={MANAGE_VIEW_PATH}>{label}</Link>;
  } else {
    return label;
  }
};
